import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import PaymentSecurity from "./PaymentSecurity";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#F5F3EE] text-[#1C1C1C] mt-32">
      <PaymentSecurity />
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 py-24 grid grid-cols-2 md:grid-cols-5 gap-12">
        <div className="col-span-2">
          <img
            src="/theratec-logo.png"
            alt="TheraTec"
            className="h-20 lg:h-24 w-auto object-contain"
          />
          <p className="mt-8 text-sm text-[#5C5C5C] max-w-sm leading-relaxed">
            Premium therapeutic equipment for the world's most discerning med spas. Sourced, engineered, and integrated with white-glove service.
          </p>
          <div className="mt-8 flex items-center gap-4" data-testid="footer-socials">
            <a
              href="https://www.instagram.com/theratec.co"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram-link"
              className="h-10 w-10 rounded-full border border-[#D8D3C7] flex items-center justify-center text-[#5C5C5C] hover:text-[#C9A961] hover:border-[#C9A961] transition-colors duration-300"
            >
              <Instagram size={16} strokeWidth={1.5} />
            </a>
            <a
              href="https://www.facebook.com/theratec.co"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              data-testid="footer-facebook-link"
              className="h-10 w-10 rounded-full border border-[#D8D3C7] flex items-center justify-center text-[#5C5C5C] hover:text-[#C9A961] hover:border-[#C9A961] transition-colors duration-300"
            >
              <Facebook size={16} strokeWidth={1.5} />
            </a>
            <a
              href="https://www.linkedin.com/company/theratec"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-linkedin-link"
              className="h-10 w-10 rounded-full border border-[#D8D3C7] flex items-center justify-center text-[#5C5C5C] hover:text-[#C9A961] hover:border-[#C9A961] transition-colors duration-300"
            >
              <Linkedin size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>
        <div>
          <div className="overline text-[#5C5C5C]">Shop</div>
          <ul className="mt-6 space-y-3 text-sm">
            <li><Link to="/shop" className="hover:text-[#C9A961] transition-colors duration-300">All Equipment</Link></li>
            <li><Link to="/hyperbaric" className="hover:text-[#C9A961] transition-colors duration-300">Hyperbaric</Link></li>
            <li><Link to="/shop?category=IV %26 Wellness Tables" className="hover:text-[#C9A961] transition-colors duration-300">IV Suites</Link></li>
            <li><Link to="/shop?category=Detox Systems" className="hover:text-[#C9A961] transition-colors duration-300">Detox</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-[#5C5C5C]">The House</div>
          <ul className="mt-6 space-y-3 text-sm">
            <li><Link to="/integration" className="hover:text-[#C9A961] transition-colors duration-300">Integration</Link></li>
            <li><a href="mailto:admin@theratec.co" className="hover:text-[#C9A961] transition-colors duration-300">Concierge</a></li>
            <li><Link to="/login" className="hover:text-[#C9A961] transition-colors duration-300">Trade Portal</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-[#5C5C5C]">Contact</div>
          <ul className="mt-6 space-y-4 text-sm">
            <li>
              <a
                href="mailto:admin@theratec.co"
                data-testid="footer-email-link"
                className="inline-flex items-center gap-2 hover:text-[#C9A961] transition-colors duration-300"
              >
                <Mail size={14} strokeWidth={1.5} className="text-[#C9A961]" />
                admin@theratec.co
              </a>
            </li>
            <li data-testid="footer-support">
              <a
                href="mailto:Support@theratec.co"
                data-testid="footer-support-email-link"
                className="inline-flex items-center gap-2 hover:text-[#C9A961] transition-colors duration-300"
              >
                <Mail size={14} strokeWidth={1.5} className="text-[#C9A961]" />
                Support@theratec.co
              </a>
              <div className="mt-1 pl-[22px] text-xs text-[#5C5C5C] leading-relaxed">
                For any queries regarding equipment or questions.
              </div>
            </li>
            <li>
              <a
                href="tel:+16562037473"
                data-testid="footer-phone-link"
                className="inline-flex items-center gap-2 hover:text-[#C9A961] transition-colors duration-300"
              >
                <Phone size={14} strokeWidth={1.5} className="text-[#C9A961]" />
                +1 (656) 203-7473
              </a>
            </li>
            <li className="flex items-start gap-2 text-[#5C5C5C] leading-relaxed" data-testid="footer-address">
              <MapPin size={14} strokeWidth={1.5} className="text-[#C9A961] mt-0.5 shrink-0" />
              <span>
                5401 S Kirkman Dr, Ste 310<br />
                Orlando, FL 32819
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#D8D3C7] px-6 lg:px-12 py-8 max-w-[1440px] mx-auto flex flex-col md:flex-row justify-between text-xs text-[#5C5C5C]">
        <div>© {new Date().getFullYear()} TheraTec Equipment Co. All rights reserved.</div>
        <div className="mt-2 md:mt-0">Crafted for medical aesthetics.</div>
      </div>
    </footer>
  );
}
